import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { TagsWithPopover } from "../../../Shared/TagsWithPopover/TagsWithPopover";
import type { Port } from "../request/request";

export const columns: GenericTableColumn<Port>[] = [
  {
    header: "Port Number",
    accessor: "portNumber",
    width: "150px",
    renderCell: (row: Port) => (
      <div className="max-w-[150px] overflow-x-auto thin-scroll">
        <span className="whitespace-nowrap inline-block">{row.portNumber || "-"}</span>
      </div>
    ),
  },
  {
    header: "Type",
    accessor: "portType",
    width: "120px",
    renderCell: (row: Port) => (
      <div className="max-w-[120px] overflow-x-auto thin-scroll">
        <span className="whitespace-nowrap inline-block">{row.portType || "-"}</span>
      </div>
    ),
  },
  {
    header: "Port Name",
    accessor: "portName",
    width: "200px",
    renderCell: (row: Port) => (
      <div className="max-w-[200px] overflow-x-auto thin-scroll">
        <span className="whitespace-nowrap inline-block">{row.portName || "-"}</span>
      </div>
    ),
  },
  {
    header: "Hardware Hostname",
    accessor: "hardwareHostname",
    width: "200px",
    renderCell: (row: Port) => (
      <div className="max-w-[200px] overflow-x-auto thin-scroll">
        <span className="whitespace-nowrap inline-block">{row.hardwareHostname || "-"}</span>
      </div>
    ),
  },
  {
    header: "Datacenter",
    accessor: "datacenterDisplayName",
    width: "200px",
    renderCell: (row: Port) => (
      <div className="max-w-[200px] overflow-x-auto thin-scroll">
        <span className="whitespace-nowrap inline-block">{row.datacenterDisplayName || "-"}</span>
      </div>
    ),
  },
  {
    header: "Status",
    width: "180px",
    renderCell: (row: Port) => {
      const status = row.portStatus || "";
      return (
        <GenericTag
          variant="neutral"
          label={status || "-"}
          size="small"
        />
      );
    },
    sortAccessor: (row: Port) => row.portStatus || "",
  },
  {
    header: "Availability",
    width: "120px",
    renderCell: (row: Port) => {
      const clientAssignation = row.clientAssignation?.toLowerCase() || "";
      let label: string;
      let variant: "success" | "default" | "warning" = "default";
      
      if (clientAssignation === "assigned") {
        label = "Assigned";
        variant = "success";
      } else if (clientAssignation === "occupied") {
        label = "Occupied";
        variant = "warning";
      } else {
        // unassigned, null, or empty string → show "Unassigned"
        label = "Unassigned";
        variant = "default";
      }
      
      return (
        <GenericTag
          variant={variant}
          label={label}
          size="small"
        />
      );
    },
    sortAccessor: (row: Port) => {
      const clientAssignation = row.clientAssignation?.toLowerCase() || "";
      if (clientAssignation === "assigned") return "Assigned";
      if (clientAssignation === "occupied") return "Occupied";
      return "Unassigned";
    },
  },
  {
    header: "KE Ports",
    width: "200px",
    renderCell: (row: Port) => {
      const kePorts = row.KEPorts || [];
      if (kePorts.length === 0) {
        return <span className="text-semantic-text-secondary">-</span>;
      }
      const subscriptionIds = kePorts.map((ke) => ke.subscriptionId);
      return (
        <TagsWithPopover
          tags={subscriptionIds}
          maxVisible={1}
          copyOnClick={false}
        />
      );
    },
  },
  {
    header: "Actions",
    accessor: "id",
    width: "200px",
    renderCell: () => (
      <div className="flex items-center gap-2">
        {/* Actions will be overridden in PortInventoryPage.tsx */}
      </div>
    ),
  },
];
